module.exports = __webpack_public_path__ + "img/img_a@2x.f85e365c.png";